import { imageUrl as baseImageUrl } from "lemans-brandsites-common/libs/imageUrl";

export const imageUrl = baseImageUrl('/img/z1r_image_unavailable.jpg');